import { LiveAnnouncer } from '@angular/cdk/a11y';
import { SelectionModel } from '@angular/cdk/collections';
import { AfterViewInit, Component, EventEmitter, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AppMasterService } from 'app/business/service/app/app-master.service';
import { ConfirmPopupComponent } from '../confirm-popup/confirm-popup.component';
import { DatePipe } from '@angular/common';
import { MarkTypeDetailPopupComponent } from './mark-type-detail-popup/mark-type-detail-popup.component';
import { ActivatedRoute } from '@angular/router';
import _ from 'underscore';
import { ConfirmDialogService } from '@bundle/component/confirm-dialog/confirm-dialog.service';

@Component({
  selector: 'app-mark-type-detail-inquiry',
  templateUrl: './mark-type-detail-inquiry.component.html',
  styleUrls: ['./mark-type-detail-inquiry.component.css']
})
export class MarkTypeDetailInquiryComponent implements OnInit, AfterViewInit {
  BenefitTarget: any = [];
  form: any = {};
  BenefitTargetValue: string;
  fieldType: any[] = [];
  attachType: any[] = [];
  displayedColumns: string[] = ['marktypeName', 'marktypeDetail', 'createDate', 'updateDate', 'action'];
  dataSource = new MatTableDataSource<any>();
  selection = new SelectionModel<any>(true, []);
  datePipe: DatePipe = new DatePipe('en-US');
  marktypeHId: any;
  markdetail: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @Output() itemLoadEvent: EventEmitter<any> = new EventEmitter();

  constructor(
    private _liveAnnouncer: LiveAnnouncer,
    private dialog: MatDialog,
    private appMasterService: AppMasterService,
    private route: ActivatedRoute,
    private confirmDialogService: ConfirmDialogService
  ) {
    const { marktypeHId } = this.route.snapshot.queryParams;
    this.marktypeHId = marktypeHId;
  }

  ngOnInit(): void {
    this.BenefitTarget = [{ benefitTargetCode: 1, benefitTargetTName: '10' }, { benefitTargetCode: 2, benefitTargetTName: '20' }];
    this.form.isActive = 'A';
    this.loadData();
  }
  loadData() {
    const data = {
      "marktypeHId": this.marktypeHId
    };

    this.appMasterService.getMarktypeDetailList(data).then((res: any) => {
      if (res === "error") {
        return;
      } else {
        this.dataSource = new MatTableDataSource(res)
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        
        this.markdetail = res;
        this.eventEmitter();
      }
    });
  }

  eventEmitter() {
    const firstData = _.first(this.markdetail);

    const emitData = {
      attachType: firstData.attachType,
      fieldTypeName: firstData.marktypeName
    }

    this.itemLoadEvent.emit(emitData);
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  selectionPercent() {

  }
  editItem(e) {
    const data = { ...e };
    const dialogRef = this.dialog.open(MarkTypeDetailPopupComponent, {
      disableClose: false,
      width: '60vw',
      data: data,
      maxWidth: 'none'
    });

    dialogRef.afterClosed().subscribe(res => {
      this.loadData();
    });
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
    
  }

  /** Announce the change in sort state for assistive technology. */
  announceSortChange(sortState: Sort) {
    // This example uses English messages. If your application supports
    // multiple language, you would internationalize these strings.
    // Furthermore, you can customize the message to add additional
    // details about the values being sorted.
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  onAttachTypeChange(e) {
    if (e.value === 0) {
      this.form.attachTypeId = null;
    } else {
      this.form.attachTypeId = e.value;
    }

    this.loadData();
  }

  onFieldChange(e) {
    if (e.value === 0) {
      this.form.fieldTypeId = null;
    } else {
      this.form.fieldTypeId = e.value;
    }

    this.loadData();
  }

  save() {

  }

  addAccount(data): void {
    const predata = {
      marktypeHId: this.marktypeHId,
      isActive: "Y"
    };

    const dialogRef = this.dialog.open(MarkTypeDetailPopupComponent, {
      disableClose: false,
      width: '60vw',
      data: predata,
      maxWidth: 'none'
    });

    dialogRef.afterClosed().subscribe(res => {
      this.loadData();
    });
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  delete(e) {
    this.confirmDialogService.open({ header: "", content: "คุณต้องการลบข้อมูลนี้หรือไม่?" }).then(res => {
      if (res) {
        const data = {
          marktypeDId: e.marktypeDId,
          marktypeHId: e.marktypeHId,
          marktypeDetail: e.marktypeDetail,
          isActive: "N"
        };

        this.appMasterService.saveMarktypeDetail(data).then((res: any) => {
          if (res === "error") {
            return;
          } else {
            this.loadData();
          }
        });
      }
    });
  }

}
